module.exports = __webpack_public_path__ + "img/lr.9732562e.svg";